import {
    CORE_LOAD_MASTER_DATA_WAREHOUSES_REQUEST,
    CORE_LOAD_MASTER_DATA_WAREHOUSES_SUCCESS,
    CORE_LOAD_MASTER_DATA_WAREHOUSES_FAILURE,

} from '../../masterDataTypes'
import { REQUEST_STATE } from '../../types'

const requestState = REQUEST_STATE

export default {
    masterWarehouses: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_MASTER_DATA_WAREHOUSES_REQUEST:
                return state
            case CORE_LOAD_MASTER_DATA_WAREHOUSES_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    } else return []
                } else {
                    return []
                }
            case CORE_LOAD_MASTER_DATA_WAREHOUSES_FAILURE:
                return []
            default:
                return state
        }
    },

}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/masterDatas/warehouse.js